import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    color: #1f1f1f;
    height: auto;
    background-color: #fff;
    font-family: "Noto Sans JP", sans-serif;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
`

export default GlobalStyle
